import { useEffect, useRef, useState } from "react";
import blinkscribeapi from "../../../../../api/blinkscribeapi";
import { AudioCardGrid, Audiocards } from "../audiocards";
import { Backdrop, CircularProgress } from "@mui/material";
import PdfRender from "../../../../../utils/pdfhandlers/pdfrender";
import ImageModal from "../../../../../blinkscribe/modals/showimg";
import { eventBus } from "../../../../../utils/eventBus";
import Editscreen from "../../../../../blinkscribe/archeivescreens/editscreen";
import dayjs from "dayjs";



const RenderBlinkscribeRecords = ({ view,  setSelectedDateRange,
        selectedDateRange ,data, searchDate, internavtab, }) => {
const [record, setRecords] = useState([]);
const [loading, setLoading] = useState(false);
const[showpdf,setIspdfShow]=useState(false)
const [audioSrc, setAudioSrc] = useState(null);
const [isModalOpen, setIsModalOpen] = useState(false);
const [pdffile,setPdffile]=useState('')
const [selectedCard,setSelectedCard]=useState('')
const [mycard,setMyCard]=useState('')
const [imgsrc,setImgSrc]=useState('')
const [isShowimg,setIsShowImg]=useState(false)
const [showloader,setShowLoader]=useState(false);
const [isEditscreen,setIsEditScreen]=useState(false)
const[editcard,setEditCard]=useState({})

const [page, setPage] = useState(1);
const [rowsPerPage, setRowsPerPage] = useState(5);
  const fetchblinkscribeRecords = async (isblockloader=false) => {
    if(!isblockloader){
          setLoading(true);
    }

    try {
       const payload = {
      filter_array: {
        date_filter: {}
      }
    };

       if (selectedDateRange?.startDate && selectedDateRange?.endDate) {
      payload.filter_array.date_filter = {
        start_date: dayjs(selectedDateRange.startDate).format("YYYY-MM-DD"),
        end_date: dayjs(selectedDateRange.endDate).format("YYYY-MM-DD"),
      };
    }
      const response = await blinkscribeapi.post(
        `/v1/patient/${data.patientid}/recording/details`,
        payload
      );
      if (response.status === 200) {
 const sorted = (response?.data || []).sort(
    (a, b) => dayjs(b.ts).valueOf() - dayjs(a.ts).valueOf()
  );

  setRecords(sorted);
      }else{
        setRecords([])
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  // Latest fetch for the refreshDashboard listener (subscribed once below), so
  // it sees current props instead of the first render's closure.
  const fetchRef = useRef(fetchblinkscribeRecords);
  fetchRef.current = fetchblinkscribeRecords;
const totalEntries = record.length;
const totalPages = Math.ceil(totalEntries / rowsPerPage);

const startIndex = (page - 1) * rowsPerPage;
const endIndex = startIndex + rowsPerPage;

const paginatedRecords = record.slice(startIndex, endIndex);
  useEffect(() => {
    if (internavtab == 1) {
      fetchblinkscribeRecords();
    }
  }, [internavtab,searchDate]);



  useEffect(() => {
 
const interval = setInterval(() => {
        fetchblinkscribeRecords(true);
      }, 4000);
    

  return () => clearInterval(interval);
  }, [searchDate]);
useEffect(() => {
  
    setPage(1);
  
}, [selectedDateRange]);
 useEffect(() => {
    // Listen for 'refreshDashboard' event
    const handleRefresh = () => fetchRef.current();
    eventBus.on('refreshDashboard', handleRefresh);

    return () => {
      // Remove ONLY this listener. Removing all 'refreshDashboard' listeners also
      // dropped the dashboard/chart subscribers (brainycarehome, patientchartwrap,
      // LiveScribePanel), so later emits (e.g. CareIQ order create) did nothing.
      eventBus.off('refreshDashboard', handleRefresh);
    };
  }, []);
  const handleImg = async (value, card) => {
    setShowLoader(true);
  
    if (card.transcriptionstatus === 'Processing') {
      // Optional: Show a message to the user if needed
      return;
    }
  
    try {
      const uniqueParam = new Date().getTime();
  
const response = await blinkscribeapi.get(`/v1/documents/PDF/${value}?_=${uniqueParam}`, {
  responseType: 'blob',
});

const pdfBlob = response;
const pdfArrayBuffer = await pdfBlob.arrayBuffer();

// Load PDF
const pdf = await window.pdfjsLib.getDocument({ data: pdfArrayBuffer }).promise;

const scale = 2;
const pageCanvases = [];

let totalHeight = 0;
let maxWidth = 0;

// Step 1: Render each page to its own canvas
for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
  const page = await pdf.getPage(pageNum);
  const viewport = page.getViewport({ scale });

  const canvas = document.createElement('canvas');
  const context = canvas.getContext('2d');
  canvas.width = viewport.width;
  canvas.height = viewport.height;

  await page.render({ canvasContext: context, viewport }).promise;

  pageCanvases.push(canvas);
  totalHeight += canvas.height;
  maxWidth = Math.max(maxWidth, canvas.width);
}

// Step 2: Create a new canvas to combine all pages
const combinedCanvas = document.createElement('canvas');
combinedCanvas.width = maxWidth;
combinedCanvas.height = totalHeight;
const combinedCtx = combinedCanvas.getContext('2d');

// Step 3: Draw each canvas onto the combined canvas
let yOffset = 0;
for (const canvas of pageCanvases) {
  combinedCtx.drawImage(canvas, 0, yOffset);
  yOffset += canvas.height;
}

// Step 4: Export the final image
combinedCanvas.toBlob((blob) => {
  const imageUrl = URL.createObjectURL(blob);
  window.open(imageUrl, '_blank'); // You can zoom in here using browser zoom
}, 'image/png');

     
  
    } catch (error) {
      console.error("Error fetching the file:", error);
    } finally {
      setShowLoader(false);
    }
  };
  
  const handlepdf = async (value,card) => {
setShowLoader(true)
    if(card.transcriptionstatus=='Processing'){
      // setMessage('Update in process. Hold on!');
      // setSeverity('info'); // Change severity as needed
      // setOpen(true);
      return
    }

    try {
      // Trigger loading spinner
   

      const uniqueParam = new Date().getTime(); // or use a random number: Math.random()

    // Fetch the PDF from the server with a unique parameter to prevent caching
    const response = await blinkscribeapi.get(`/v1/documents/PDF/${value}?_=${uniqueParam}`, {
      responseType: "blob", // Ensure response type is 'blob' for binary data
    });
      // Fetch the PDF from the server
      // const response = await api.get(`/v1/documents/PDF/${value}`, {
      //   responseType: "blob", // Ensure response type is 'blob' for binary data
      // });
      // // Create a Blob from the PDF data
      const pdfBlob = new Blob([response], { type: "application/pdf" });

      // Generate a URL for the Blob
      const pdfUrl = URL.createObjectURL(pdfBlob);
      setMyCard(card)
      setPdffile(pdfBlob)
      // Open the generated URL in a new tab
      //window.open(pdfUrl, "_blank");

    } catch (error) {
      console.error("Error fetching the PDF:", error);
    } finally {
      // Turn off loading spinner
  
      setIspdfShow(true)
      setShowLoader(false)
    }
  };
  const handleplay=async(audio_link)=>{
    try {
     setShowLoader(true)
      const response = await blinkscribeapi.get(`/v1/audio/${audio_link}`, {
        responseType: "blob", // Make sure response is treated as a Blob
      });
      const fileBlob = response;
      const audioURL = URL.createObjectURL(fileBlob);
          setAudioSrc(audioURL);
          console.log(audioURL)
          if(fileBlob&&fileBlob.size==0){
         setAudioSrc('')
          }
        setIsModalOpen(true)
    } catch (error) {
      console.log(error)
    }finally{
  setShowLoader(false)
    }
   }
  return (
    <>
     <div className="flex flex-col gap-4 overflow-y-auto max-h-screen p-4">
    {loading ? null : paginatedRecords?.length === 0 && (
        <div className="text-center text-gray-500">No records found</div>
    )}

    {!view ? (
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-3">
            {paginatedRecords?.map((card, index) => (
                <AudioCardGrid 
                    key={index} 
                    card={card} 
                    handlepdf={handlepdf} 
                    handleplay={handleplay} 
                      searchDate={searchDate}
                    audioSrc={audioSrc} 
                    setIsEditScreen={setIsEditScreen}
                    selectedCard={selectedCard}
                    setSelectedCard={setSelectedCard}
                    setAudioSrc={setAudioSrc}
                    fetchimg={handleImg}
                    data={data}
                    setEditCard={setEditCard}
                />
            ))}
        </div>
    ) : (
        <div className="flex flex-col gap-4">
            {paginatedRecords?.map((card, index) => (
                <Audiocards 
                    key={index} 
                    card={card} 
                    searchDate={searchDate}
                    handlepdf={handlepdf} 
                    setIsEditScreen={setIsEditScreen}
                    handleplay={handleplay} 
                    audioSrc={audioSrc}
                    selectedCard={selectedCard}
                    setSelectedCard={setSelectedCard}
                      setEditCard={setEditCard}
                    setAudioSrc={setAudioSrc}
                    fetchimg={handleImg}
                    data={data}
                />
            ))}
        </div>
    )}
</div>
{totalEntries > 0 && (
<div className="flex justify-between items-center mt-4 text-sm">

  {/* Left Side */}
  <div className="text-gray-500">
    Showing {startIndex + 1} -
    {Math.min(endIndex, totalEntries)} of {totalEntries} entries
  </div>

  {/* Right Side */}
  <div className="flex items-center gap-3">

    <span>per page</span>

    <select
      value={rowsPerPage}
      onChange={(e) => {
        setRowsPerPage(Number(e.target.value));
        setPage(1);
      }}
      className="border rounded px-2 py-1"
    >
      <option value={5}>5</option>
      <option value={10}>10</option>
      <option value={20}>20</option>
      <option value={50}>50</option>
    </select>

    <button
      disabled={page === 1}
      onClick={() => setPage((p) => p - 1)}
      className="px-3 py-1 border rounded disabled:opacity-50"
    >
      Previous
    </button>

    <span className="px-3 py-1 bg-blue-900 text-white rounded">
      {page}
    </span>

    <button
      disabled={page === totalPages}
      onClick={() => setPage((p) => p + 1)}
      className="px-3 py-1 border rounded disabled:opacity-50"
    >
      Next
    </button>

  </div>
</div>
)}

{isEditscreen?<Editscreen  selectedRecord={editcard} setIsEditScreen={setIsEditScreen} />:<></>}
<ImageModal
        isShowImg={isShowimg} 
        imgSrc={imgsrc} 
        onClose={() => setIsShowImg(false)} 
      />
      <PdfRender setIsEditScreen={setIsEditScreen} ispdfshow={showpdf}setIspdfShow={setIspdfShow} pdfBlob={pdffile} data={mycard}
        mergePending={!!(mycard && Array.isArray(record) && record.some(r => r && r.id !== mycard.id
          && String(r.config_appointmentid || '') === String(mycard.config_appointmentid || '')
          && (r.transcriptionstatus === 'Processing' || r.transcriptionstatus === 'Submitted')))}/>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading||showloader}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};

export default RenderBlinkscribeRecords;
